import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Constants } from '../../shared/Constants';
import { IWorkOrder } from '../work-order/new-work-order/new-work-order.component';
@Injectable()
export class ProjectService {

  constructor(private http: HttpClient) {

  }

  getProjects() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/projects', { headers: headers });
  }

  getProjectsByName(name) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/projectFilter?name=' + name, { headers: headers });
  }

  getProjectsByNameOC(name) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/projectFilterWork?name=' + name, { headers: headers });
  }

  archivarMultipleProject(updateData: IWorkOrder) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.put(Constants.URL_BACKEND + '/archivarMultipleProject/project', { data: updateData }, { headers: headers });
  }

  getDetailProject(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/projects/' + id, { headers: headers });
  }

  createProject(projectData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/projects/', { data: projectData }, { headers: headers });
  }

  updateProject(idProject, updateData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/projects/' + idProject, { data: updateData }, { headers: headers });
  }


  updateProjectArchivar(state, work_order_id) {
    console.log(state);
    console.log(work_order_id);
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/projectsUpdateArchivar', { state: state, work_order_id: work_order_id }, {headers: headers });
  }

  getArchiveProjects(){
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/projects/archived', { headers: headers });
  }



}


// WEBPACK FOOTER //
// ./src/app/system/services/project.service.ts